<template>
    <div>
      <div class="home">
        <hd></hd> 
        <div style="height: 300px;margin: 144px auto 94px;text-align: center;
        font-size: 30px;
        padding-top: 50px;">
            <div style="margin-bottom:20px;">
                <i class="el-icon-error" style="font-size: 78px;color: #FF4650;"></i>
            </div>
            任务已支付
        </div>       
        <mobilefooter v-if="mobiletype"></mobilefooter>
        <ft v-else></ft>
        
      </div>
    </div>
  </template>
  
  <script>
  import api from '../../services/api.js'
  import hd from '../../components/Header'
  import ft from '../../components/Footer'
  import mobilefooter from '../../components/mobilefooter'
  
  
  export default {
    name: 'Home',
    components: {
      mobilefooter: mobilefooter,
      hd: hd,
      ft: ft,
    },
    data() {
      return {
        bindVisible: false,
        userInfo: {},
        mobiletype: false,
        screenWidth: document.body.clientWidth,
      }
    },
    created () {
      if (document.body.clientWidth < 1024) {
        this.mobiletype = true
      }
    },
    mounted() {
      const that = this
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()
  
      }
    },
    watch: {
      screenWidth (val) {
        if (!this.timer) {
          this.screenWidth = val
          console.log(val)
          if (val < 1024) {
            this.mobiletype = true
          }
          else {
            this.mobiletype = false
          }
          this.timer = true
          let that = this
          setTimeout(function () {
            // that.screenWidth = tha t.$store.state.canvasWidth
            that.timer = false
          }, 400)
        }
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="scss">
    .home{
      z-index: 99;
    }
  </style>
  


// WEBPACK FOOTER //
// src/pages/home/taskpay.vue